module.exports = __webpack_public_path__ + "img/bcc073.8185126f.jpeg";